import type { JSX } from 'react';

import { useClearCache } from '../../hooks/useClearCache';
import { Button } from '../Button/Button';

import styles from './FatalErrorPage.module.css';

export default function FatalErrorPage(): JSX.Element {
  const { clearCache } = useClearCache();

  const handleRefresh = async () => {
    await clearCache();
    window.location.reload();
  };

  return (
    <div className={styles.Container}>
      <div className={styles.Content}>
        <h1 className={styles.Title}>Oh oh! This is unexpected.</h1>
        <p className={styles.Subtitle}>
          An error has occurred and we're working to fix the problem!
        </p>
        <p className={styles.TryAgain}>Please try again later.</p>
        <p className={styles.Description}>If you would like to help, tell us what happened.</p>
        <div className={styles.ActionButtons}>
          <Button
            variant="primary"
            onClick={() => window.open('mailto:alerts@revvly.ai', '_blank')}
          >
            Tell us what happened
          </Button>
          <div className={styles.OrDivider}>
            <span>or</span>
          </div>
          <Button variant="outline" onClick={handleRefresh}>
            Refresh the page
          </Button>
        </div>
        <div className={styles.FootNote}>Thanks for your patience.</div>
      </div>
    </div>
  );
}
